import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import Form from '@grnhse/seedling/lib/birch/components/forms/form';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import type { RediscoveryProps } from 'talent_matching/types';
import {
  RediscoveryPageContent,
  buildDefaultValues,
} from 'talent_matching/talent_rediscovery/rediscovery_page_content';
import { RediscoveryUserContextProvider } from 'talent_matching/contexts/rediscovery_user_context';
import noop from 'lodash/noop';

const TalentRediscovery = (
  rediscoveryProps: RediscoveryProps & { isActive?: boolean }
) => {
  const { isActive = true, ...props } = rediscoveryProps;

  if (!props.paths) {
    return (
      <Stack spacing={2}>
        <Body>{'Talent Rediscovery is not available.'}</Body>
      </Stack>
    );
  }

  const defaultValues = buildDefaultValues(props.userDateFormat);

  return (
    <RediscoveryUserContextProvider
      rediscoveryProps={props}
      isActive={isActive}
    >
      <Form defaultValues={defaultValues} onSubmit={noop} submitMode="preserve">
        <RediscoveryPageContent defaultValues={defaultValues} />
      </Form>
    </RediscoveryUserContextProvider>
  );
};

export default TalentRediscovery;
